// extracted by mini-css-extract-plugin
module.exports = {"privacyAndTermsContainer":"privacy-and-terms-module--privacyAndTermsContainer--1p1U0"};